export const LOCALES = {
    ENGLISH: 'en-US',
    FRANCAIS: 'fr-FR',
    ARABE: 'ar-AG',
};